// components/LogoComponent.js
import Box from "@mui/material/Box";
import { Logo } from "pepsico-ds";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useEffect, useRef } from "react";
import { getAPI } from "../../../API/ApiService";
import { BASE_URL } from "../../../constant/apiUrl";
import { useDispatch } from "react-redux";
import { setPageFilter } from "../../../slices/pageSlice";
import image from "../../../assets/pepsi2.png";
import PepsiCoLogoSvg from "./PepsiCoLogoSvg";
const LogoComponent = () => {
  const isDarkTheme = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/");
  };
  const dispatch = useDispatch();
  const hasfetched = useRef();
  useEffect(() => {
    const fetchFilters = async () => {
      const response = await getAPI(
        `${BASE_URL}/page-builder/lov-filter/find-all`
      );
      dispatch(setPageFilter(response?.data?.response));
    };
    if (!hasfetched.current) {
      hasfetched.current = true;
      fetchFilters();
    }
  }, []);

  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <PepsiCoLogoSvg
          data-testid="logo"
          style={{ width: "124px", cursor: "pointer", height: "auto" }}
          onClick={handleNavigate}
        />
      </Box>
    </Box>
  );
};

export default LogoComponent;
